import { DataSourceFactory } from 'app/components'

interface IMockData {
  firstName: string
  lastName: string,
  salary: number
}

const generateMockData = () => {
  const mockData: IMockData[] = []

  for (let i = 0; i < 100; i++) {
    const firstName = (i % 2) ? `John ${i}` : `Jane ${i}`
    const lastName = (i % 2) ? `Smith` : `Doe`
    const salary = Math.round(Math.random() * 10000)

    mockData.push({ firstName, lastName, salary })
  }

  return mockData;
}

const PersonalWagesDataSource = DataSourceFactory.create<IMockData>({
  data: generateMockData()
})

const AccountUsersDataSource = DataSourceFactory.create<any>({
  /*
  transport: {
    init: {
      url: 'http://174.129.110.160/api/connect?input={"con_string":"jdbc:dc_postgresql://localhost:5432/WorkpapersDB?user=postgres%26password=yellowfin1!"}',
      variables: { $connectionID: 'id' }
    },
    read: {
      url: 'http://174.129.110.160/api/query',
      dataPathExpression: 'results',
      request: {
        method: 'POST',
        params: {
          input: '{"connId":"$connectionID","query":"SELECT accounts_users.activation_code as activation_code FROM AXON.accounts_users"}'
        }
      }
    }
  }*/
  data: []
})

export {
  AccountUsersDataSource,
  PersonalWagesDataSource
}



// WEBPACK FOOTER //
// ./src/app/containers/Dashboard/DataSources.ts